import urlBuilder from "app/umbraco/helpers/urlBuilder";
import getUmbracoEndPoint from "app/umbraco/helpers/UmbracoEndPoint";

export default async (route: string, language: string): Promise<any[]> => {
    const url = urlBuilder("/api/product/filter", { route: route });

    const response = await fetch(url.toString(), {
        method: "POST",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
            "Origin": getUmbracoEndPoint(),
            "X-Request-Domain": getUmbracoEndPoint()
        },
        body: JSON.stringify({
            "language": language ?? "da"
        })
    });

    return await response.json();
};